import { useEffect } from "react";

const ELFSIGHT_SCRIPT_SRC = "https://elfsightcdn.com/platform.js";

function Review() {
  useEffect(() => {
    const existingScript = document.querySelector(
      `script[src="${ELFSIGHT_SCRIPT_SRC}"]`
    );

    if (existingScript) {
      return;
    }

    const script = document.createElement("script");
    script.src = ELFSIGHT_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section className="mx-auto max-w-7xl px-4 py-10 md:px-6">
      <h1 className="mb-6 text-2xl font-semibold md:text-3xl">Reviews</h1>
      <div
        className="elfsight-app-56efeca9-74bb-4164-9af7-f36e2735c3fa"
        data-elfsight-app-lazy
      />
    </section>
  );
}

export default Review;
